import {createGrid} from "../../helpers/grids/grids";
import createElement from "../../helpers/createElement";
import Axios from "axios";
import {handleAjaxSuccess, swalConfirm} from "../../helpers/swalHelper";
import handleAjaxError from "../../helpers/handleAjaxError";
import {loading, stopLoading} from "../../helpers/loading";
import {createCellRenderer, createDoubleClickHandler} from "../../helpers/grids/helpers";

function initCompaniesIndex() {

	// Init grid
	const grid = createGrid('.companies-grid', {
			columnDefs: [
				{
					field: "name",
					headerName: 'Name',
					sortable: true,
				},
				{
					field: "state",
					headerName: 'State',
					sortable: true,
				},
				{
					field: "country",
					headerName: 'Country',
					sortable: true,
				},
				{
					field: "public_id",
					headerName: '',
					maxWidth: 300,
					cellRenderer: createCellRenderer(params => {
						// noinspection JSUnresolvedVariable
						const buttons = createElement(`
                            <div class="buttons">
                            	<a class="btn btn-primary btn-sm" href="${params.data.detail_url}">
                                    <i class="fa-solid fa-eye"></i>
                                    View
								</a>
                                <a class="btn btn-primary btn-sm" href="${params.data.edit_url}">
                                    <i class="fa-solid fa-user-pen"></i>
                                    Edit
								</a>
                                <button type="button" class="btn btn-danger btn-sm remove-company-button">
                                    <i class="fa-solid fa-trash"></i>
                                    Remove
                                </button>
                            </div>`
						)

						const deleteButton = buttons.querySelector('.remove-company-button');

						deleteButton.onclick = () => removeCompany(params.data);

						// Remove delete button from admin
						if (params.data.id === 1) {
							deleteButton.remove();
						}

						return buttons;
					})
				},
			],
			paginationPageSize: 20,
			_rowName: 'Companies',
			rowClass: 'cursor-pointer',
			onRowDoubleClicked: createDoubleClickHandler(data => {
				loading();
				// noinspection JSUnresolvedVariable
				window.location.href = data.edit_url;
			}),
		},
		window['routes/admin.companies.grid'],
		() => {
			return {}
		}
	);

	/** Methods */

	function removeCompany(user) {
		swalConfirm({
			title: 'Are you sure you want to delete this company?'
		}).then(response => {
			if (response.isConfirmed) {
				loading();

				// noinspection JSUnresolvedVariable
				Axios.post(user.remove_url)
					.then(handleAjaxSuccess)
					.catch(handleAjaxError)
					.finally(stopLoading);
			}
		})

	}
}

export {
	initCompaniesIndex
}
